import ACallingCustomerInfo from './index.vue';

ACallingCustomerInfo.install = app => {
  app.component(ACallingCustomerInfo.name, ACallingCustomerInfo);
};

export default ACallingCustomerInfo;
